import type { FC } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft01FreeIcons } from "@hugeicons/core-free-icons";

import { useRegistrationStore } from "@/store/registrationStore.ts";
import { i18n } from "@/localization";

interface StepNavigationProps {
	onBack?: () => void;
}

export const StepNavigation: FC<StepNavigationProps> = ({ onBack }) => {
	const { prevStep } = useRegistrationStore();

	return (
		<div className="flex items-center justify-start">
			<button
				type="button"
				onClick={onBack ?? prevStep}
				className="text-brand-primary-900 -my-3 flex items-center gap-1 py-3 text-sm font-medium hover:underline"
			>
				<HugeiconsIcon icon={ArrowLeft01FreeIcons} size={16} />
				{i18n("wizard.back")}
			</button>
		</div>
	);
};
